/* tslint:disable */
import {
  UserModel
} from '../index';

declare var Object: any;
export interface ContractorInterface {
  "name": string;
  "address"?: any;
  "contactPerson"?: string;
  "email"?: string;
  "phoneNumber"?: string;
  "id"?: any;
  "contractorManagerId"?: any;
  manager?: UserModel;
  users?: UserModel[];
}

export class Contractor implements ContractorInterface {
  "name": string;
  "address": any;
  "contactPerson": string;
  "email": string;
  "phoneNumber": string;
  "id": any;
  "contractorManagerId": any;
  manager: UserModel;
  users: UserModel[];
  constructor(data?: ContractorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Contractor`.
   */
  public static getModelName() {
    return "Contractor";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Contractor for dynamic purposes.
  **/
  public static factory(data: ContractorInterface): Contractor{
    return new Contractor(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Contractor',
      plural: 'Contractors',
      path: 'Contractors',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'any'
        },
        "contactPerson": {
          name: 'contactPerson',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "phoneNumber": {
          name: 'phoneNumber',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "contractorManagerId": {
          name: 'contractorManagerId',
          type: 'any'
        },
      },
      relations: {
        manager: {
          name: 'manager',
          type: 'UserModel',
          model: 'UserModel',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'contractorManagerId'
        },
        users: {
          name: 'users',
          type: 'UserModel[]',
          model: 'UserModel',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'contractorUserId'
        },
      }
    }
  }
}
